import { VoiceTemplateFlowState, VoiceNode } from './VoiceTemplateReducer';

export enum VoiceTemplateActionType {
    ADD_NODE = 'ADD_NODE',
    UPDATE_NODE = 'UPDATE_NODE',
    DELETE_NODE = 'DELETE_NODE',
    ADD_INTERACTION = 'ADD_INTERACTION',
    REMOVE_INTERACTION = 'REMOVE_INTERACTION',
    SET_GRAPH = 'SET_GRAPH',
    SET_TEMPLATE_NAME = 'SET_TEMPLATE_NAME',
    SET_PLAY_MESSAGE_CONTENT = 'SET_PLAY_MESSAGE_CONTENT',
}

type AddNodeAction = {
    type: VoiceTemplateActionType.ADD_NODE;
    payload: { nodeId: string; nodeData: VoiceNode };
};

type UpdateNodeAction = {
    type: VoiceTemplateActionType.UPDATE_NODE;
    payload: { nodeId: string; updates: Partial<VoiceNode> };
};

type DeleteNodeAction = {
    type: VoiceTemplateActionType.DELETE_NODE;
    payload: { nodeId: string };
};

type AddInteractionAction = {
    type: VoiceTemplateActionType.ADD_INTERACTION;
    payload: { parentNodeId: string; actionKey: string; childNodeId: string };
};

type RemoveInteractionAction = {
    type: VoiceTemplateActionType.REMOVE_INTERACTION;
    payload: { parentNodeId: string; actionKey: string };
};

type SetGraphAction = {
    type: VoiceTemplateActionType.SET_GRAPH;
    payload: VoiceTemplateFlowState;
};

type setTemplateNameAction = {
    type: VoiceTemplateActionType.SET_TEMPLATE_NAME;
    payload: string;
};

type setPlayMessageContentAction = {
    type: VoiceTemplateActionType.SET_PLAY_MESSAGE_CONTENT;
    payload: string;
};

export type VoiceTemplateAction =
    | AddNodeAction
    | UpdateNodeAction
    | DeleteNodeAction
    | AddInteractionAction
    | RemoveInteractionAction
    | SetGraphAction
    | setTemplateNameAction
    | setPlayMessageContentAction;
